import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AssignmentWidgetVariantProps } from '.';
import { numberSeparator } from '../../../../helpers/formats';
import { getMarket } from '../../../../i18n';
import { getRegistrationNumberIdentifier } from '../../../../shared/registration-number-identifier';
import { Button } from '../../../../styled-components/components/Button';
import { Form, FormGroup } from '../../../../styled-components/components/Form';
import { H3 } from '../../../../styled-components/components/Heading';
import InputError from '../../../../styled-components/components/InputError';
import InputLabel from '../../../../styled-components/components/InputLabel';
import InputText from '../../../../styled-components/components/InputText';
import Loader from '../../../../styled-components/components/Loader';
import { StackMedium, StackSmall } from '../../../../styled-components/components/Stack';
import { WidgetBox } from '../../../../styled-components/components/WidgetBox';

const WidgetProductPage = ({
  registrationNumber,
  errorRegistrationNumber,
  odometerReadingValue,
  maxOdometerReadingValue,
  errorOdometerReadingValue,
  disabled,
  loading,
  onBlur,
  onChange,
  onBlurNumber,
  onChangeNumber,
  onProceed,
}: AssignmentWidgetVariantProps) => {
  const { t } = useTranslation(['assignment', 'common', 'glossary', 'validation']);
  const marketCode = getMarket().marketCode;

  return (
    <WidgetBox $tone="secondary">
      <StackMedium>
        <H3 as="h2" $margin="small">
          {t('widgetHeading', { ns: 'assignment' })}
        </H3>
        {t('widgetBody', { ns: 'assignment' })}
      </StackMedium>
      <StackMedium>
        <Form $width="narrow">
          <FormGroup $width="half">
            <InputLabel htmlFor="assignment-widget-regnr">
              {t('registrationNumber', { ns: 'glossary' })}
            </InputLabel>
            <InputText
              type="text"
              placeholder={t('registrationNumberPlaceholder', { ns: 'common' }) || undefined}
              name="registration_number"
              id="assignment-widget-regnr"
              onBlur={onBlur}
              onChange={onChange}
              value={registrationNumber}
              unit={getRegistrationNumberIdentifier({ market: marketCode })}
            />
            {errorRegistrationNumber && !!registrationNumber && (
              <InputError>
                {t('errorWrongFormatRegistrationNumber', { ns: 'validation' })}
              </InputError>
            )}
          </FormGroup>
          <FormGroup $width="half">
            <InputLabel htmlFor="assignment-widget-odometer">
              {t('mileage', { ns: 'glossary' })}
            </InputLabel>
            <InputText
              unit={t('mileageUnit', { ns: 'glossary', count: 2 }).toLowerCase()}
              type="number"
              name="odometerReadingValue"
              id="assignment-widget-odometer"
              placeholder={t('mileage', { ns: 'glossary' }) || undefined}
              value={
                odometerReadingValue !== null && !Number.isNaN(odometerReadingValue)
                  ? odometerReadingValue
                  : ''
              }
              onBlur={onBlurNumber}
              onChange={onChangeNumber}
            />
            {errorOdometerReadingValue && !!odometerReadingValue && (
              <InputError>
                {t('errorValueBetweenTwoNumbers', {
                  ns: 'validation',
                  low: '0',
                  high: numberSeparator(maxOdometerReadingValue),
                })}
              </InputError>
            )}
          </FormGroup>
        </Form>
      </StackMedium>
      <StackMedium>
        <StackSmall>
          <Button
            $tone="primary"
            $fullWidth
            onClick={onProceed}
            title={t('widgetCta', { ns: 'assignment' })}
            disabled={disabled}
          >
            {t('widgetCta', { ns: 'assignment' })}
            {loading && <Loader inlineBlock />}
          </Button>
        </StackSmall>
        {false && (
          <StackSmall>
            <Button $tone="clear" $fullWidth>
              Läs mer
            </Button>
          </StackSmall>
        )}
      </StackMedium>
    </WidgetBox>
  );
};

export default WidgetProductPage;
